import React from 'react';
import { Button, Card, Divider, Form, Grid, Image, Modal, Segment, Table } from 'semantic-ui-react';
import { TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import { repValidationSchema } from '../adslot.constants';
import FirmDropDown from '../FirmDropDown';
import CloudinaryUploadWidget from '../CloudinaryUploadWidget';

const EditRepModal = ({ getFirms, updateRep, rep, loading }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);

    getFirms();
  };

  const handleSubmit = (rep, formik) => {
    updateRep(rep);
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Formik initialValues={rep} enableReinitialize validationSchema={repValidationSchema} onSubmit={handleSubmit}>
      {formik => (
        <Modal
          size="tiny"
          onClose={() => setOpen(false)}
          onOpen={handleOpen}
          open={open}
          trigger={
            <Table.Row key={formik.values?.id}>
              <Table.Cell>
                <Image
                  src={formik.values?.imageUrl}
                  size="mini"
                  style={{ marginRight: 20, height: 20, width: 20 }}
                  ui
                  avatar
                />
                {formik.values?.name}
              </Table.Cell>
              <Table.Cell>{formik.values?.firm?.name}</Table.Cell>
            </Table.Row>
          }
        >
          <Modal.Header>Edit realtor</Modal.Header>
          <Modal.Content scrolling>
            <Grid>
              <Grid.Column width="4">
                <Image size="tiny" rounded src={formik.values?.imageUrl} />
              </Grid.Column>
              <Grid.Column width="8">
                <Segment basic style={{ padding: 0 }} loading={loading}>
                  <Card.Header>
                    <strong>{formik.values?.name}</strong>
                  </Card.Header>
                  <Card.Meta>{formik.values?.phone}</Card.Meta>
                  <Card.Meta>{formik.values?.email}</Card.Meta>
                </Segment>
              </Grid.Column>
            </Grid>

            <Divider />

            <Form onSubmit={formik.handleSubmit} widths="equal">
              <Form.Group>
                <FirmDropDown
                  name="showcaseFirmId"
                  label="Firm"
                  formik={formik}
                  value={formik.values.showcaseFirmId}
                  onChange={formik.handleChange}
                  error={formik.touched.showcaseFirmId && Boolean(formik.errors.showcaseFirmId)}
                  errorMessage={formik.errors.showcaseFirmId}
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="name"
                  formik={formik}
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  errorMessage={formik.errors.name}
                  label="Name"
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="email"
                  formik={formik}
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  errorMessage={formik.errors.email}
                  label="Email"
                />
              </Form.Group>

              <Form.Group>
                <TextField
                  name="phone"
                  formik={formik}
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  error={formik.touched.phone && Boolean(formik.errors.phone)}
                  errorMessage={formik.errors.phone}
                  label="Phone"
                />
              </Form.Group>

              <Form.Group>
                <Form.Field width="12">
                  <TextField
                    name="imageUrl"
                    formik={formik}
                    value={formik.values.imageUrl}
                    onChange={formik.handleChange}
                    error={formik.touched.imageUrl && Boolean(formik.errors.imageUrl)}
                    errorMessage={formik.errors.imageUrl}
                    label="Image URL"
                  />
                </Form.Field>
                <Form.Field width="4" style={{ paddingTop: 20 }}>
                  <CloudinaryUploadWidget formik={formik} fieldName={'imageUrl'} />
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button content="Save" labelPosition="left" icon="save" onClick={formik.handleSubmit} positive />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  firm: selectors.getCurrentFirm(state),
  loading: selectors.users.loading(state),
});

const mapDispatchToProps = dispatch => ({
  preloadShowcaseData: bindActionCreators(actions.showcase.preloadShowcaseData, dispatch),
  updateRep: bindActionCreators(actions.rep.updateRep, dispatch),
  getFirms: bindActionCreators(actions.firm.getFirms, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditRepModal);
